import {
  CUSTOMER_SOURCE_WALK_IN_CODE,
  GET_LEAD_REACTION_BY_PHONE,
} from "app/appConfig";
import {
  PAGESIZE_ALL,
  STATUS_RESULT_PATIENT_ADVISE,
} from "app/common/LocalConst";
import { getCurrentStaff } from "app/common/LocalFunction";
import { Customer } from "app/common/Model/Customer";
import { NotePatientType } from "app/common/Model/NotePatient";
import { SearchObject } from "app/common/Model/SearchObject";
import { PageResponse } from "app/common/Model/Shared";
import {
  pagingLeadReaction,
  syncClientList,
} from "app/services/ComplaintService";
import { pagingCustomerSource } from "app/services/CustomerSourceService";
import {
  elasticStaffRevenueHistory,
  pagingElasticPatientHistory,
} from "app/services/ElasticPatient";
import { getFileById } from "app/services/FileDescriptionExtService";
import { getInvoiceItemByType } from "app/services/InvoiceItemService";
import {
  deleteItemAdvise,
  deleteNotePatient,
  getItemAdviseById,
  getNotePatientById,
  getPatientAdviseById,
  removeRalationship,
  saveItemAdvise,
  saveNotePatient,
  saveRalationship,
  updateItemAdvise,
  updateItemAdviseStatus,
} from "app/services/PatientAdvice";
import {
  getPatientOverviewById,
  getPatientOverviewByIdNotLoading,
} from "app/services/PatientService";
import { pagingServiceVat } from "app/services/ServiceVat";
import { makeAutoObservable } from "mobx";
import { toast } from "react-toastify";

const DEFAULT_VALUE = {
  patientInfo: new Customer(),
  checkinList: [],
  patientAdviceList: [],
};
const DEFAULT_PATIENT_ADVISE = {
  patientAdvice: null,
  result: STATUS_RESULT_PATIENT_ADVISE[0].value,
  customerInterestedServices: [],
  customerConfirmedServices: [],
  customerInterestedProducts: [],
  customerConfirmedProducts: [],
  customerInterestedPrepaidCards: [],
  customerConfirmedPrepaidCards: [],
  customerInterestedTreatmentCards: [],
  customerConfirmedTreatmentCards: [],
  customerConfirmedServicesPrice: [],
};
export default class PatientGeneralStore {
  constructor() {
    makeAutoObservable(this);
  }
  searchLeadReaction = {
    ...new SearchObject(),
    isComplaint: true,
    phoneNumber: null,
  };
  dataLeadReaction = null;
  pageLeadReaction = new PageResponse();

  initialPatient = {
    ...DEFAULT_VALUE,
  };
  patientAdvise = null;
  currentTab = 0;
  tabHistory = []; // để nhớ những tab đã đi qua
  tabNext = []; // để nhớ tab tương lai tức là khi ở trang 0 mà mình chọn tab 2 thì nó nhớ lại tab 2
  openChatBoxAdvise = false;
  openConfirmDeleteAdviseItem = false;
  openHistoryAdviseItem = false; // when show history advise item
  selectedFiles = [];
  currentPatientAdvise = {
    ...DEFAULT_PATIENT_ADVISE,
  };
  listVatPercent = [];
  customerSourceWalkIn = null;
  openPopupRalationShip = false;
  openHistoryPatientPopup = false;
  searchDataHistoryPatient = null;
  pageDataPatientHistory = new PageResponse();

  openUncompletedServicePopup = false;
  openHistoryStaffRevenuePopup = false;
  dataInvoiceDebtFee = null;
  openInvoiceDebtFeePopup = false;
  searchDataHistoryStaffRevenue = {
    ...new SearchObject(),
  };
  pageStaffRevenueHistory = new PageResponse();
  openConfirmDeleteRelationship = null;
  // get data tuwf crm tuongw tác của sale
  getDataLeadReaction = async () => {
    try {
      const { phoneNumber, subPhoneNumber, phoneNumber3, phoneNumber4 } =
        this.initialPatient?.patientInfo;

      const phoneNumbers = [];
      if (phoneNumber) {
        phoneNumbers.push(phoneNumber);
      }
      if (subPhoneNumber) {
        phoneNumbers.push(subPhoneNumber);
      }
      if (phoneNumber3) {
        phoneNumbers.push(phoneNumber3);
      }
      if (phoneNumber4) {
        phoneNumbers.push(phoneNumber4);
      }

      const finalParams = {
        ...this.searchLeadReaction,
        ...(GET_LEAD_REACTION_BY_PHONE ? { phoneNumbers } : { phoneNumber }),
        clientId: !GET_LEAD_REACTION_BY_PHONE
          ? this.initialPatient?.patientInfo?.crmUuid ||
          this.initialPatient?.patientInfo?.id
          : null,
        phoneNumber: null,
        // emrmappingId: !GET_LEAD_REACTION_BY_PHONE
        //   ? this.initialPatient?.patientInfo?.id
        //   : null,
      };
      const { data } = await pagingLeadReaction(finalParams);
      this.pageLeadReaction = {
        ...data,
        content: data.content,
      };
      this.dataLeadReaction = data;
    } catch (error) {
      console.error(error);
      toast.error("Lấy dữ liệu tương tác của sale có lỗi");
    }
  };

  handlePopupRalationShip = () => {
    this.openPopupRalationShip = true;
  };

  handleClosePopupRalationShip = () => {
    this.openPopupRalationShip = false;
  };

  handleAsyncDataCrmPatient = async (patient) => {
    try {
      const { data } = await syncClientList({
        pageIndex: 1,
        pageSize: 10,
        keyword: patient?.phoneNumber,
      });
      if (data) {
        toast.success("Đồng bộ DL thành công");
      }
    } catch (error) {
      console.error(error);
      toast.error("Đồng bộ DL có lỗi");
    }
  };

  handleCreateRelationship = async (relationship) => {
    try {
      let { patient, ...ortherData } = relationship;
      // if (patient?.patientAvatarId?.[0]) {
      //   patient.patientAvatarId =
      //     patient?.patientAvatarId?.[0]?.fileDescription?.id;
      // }
      const { data } = await saveRalationship({ ...ortherData, patient });
      toast.success("Lưu relationship thành công!");
      const patientId = this.initialPatient?.patientInfo?.id;
      if (patientId) {
        await this.handleGetPatientOverviewById(patientId);
      }
      this.handleClosePopupRalationShip();
      return data;
    } catch (error) {
      toast.error("Lưu relationship thất bại!");
      console.error("Lưu relationship thất bại!:", error);
    }
  };

  handleGetPatientOverviewById = async (id) => {
    getPatientOverviewById(id)
      .then(async ({ data }) => {
        if (data?.patientInfo?.patientAvatarId) {
          try {
            let patientAvatarId = data?.patientInfo?.patientAvatarId;
            let objImg = await getFileById(data?.patientInfo?.patientAvatarId);
            this.initialPatient = {
              ...data,
              patientInfo: { ...data?.patientInfo, patientAvatarId },
              avatar: URL.createObjectURL(objImg?.data),
            };
            return;
          } catch (error) {
            toast.error(error);
          }
        }

        this.initialPatient = data;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy thông tin có lỗi!");
      });
  };

  handleGetPatientOverviewByIdNotLoading = async (id) => {
    getPatientOverviewByIdNotLoading(id)
      .then(async ({ data }) => {
        if (data?.patientInfo?.patientAvatarId) {
          try {
            let patientAvatarId = data?.patientInfo?.patientAvatarId;

            let objImg = await getFileById(data?.patientInfo?.patientAvatarId);
            this.initialPatient = {
              ...data,
              patientInfo: { ...data?.patientInfo, patientAvatarId },
              avatar: URL.createObjectURL(objImg?.data),
            };
            return;
          } catch (error) {
            toast.error(error);
          }
        }

        this.initialPatient = data;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy thông tin có lỗi!");
      });
  };

  // BOX ADVISE CHAT

  handleSaveItemAdvise = (obj) => {
    let {
      customerConfirmedServices,
      customerInterestedServices,
      customerInterestedProducts,
      customerConfirmedProducts,
      customerConfirmedPrepaidCards,
      customerInterestedPrepaidCards,
      customerInterestedTreatmentCards,
      customerConfirmedTreatmentCards,
    } = obj;
    if (customerConfirmedServices?.length > 0) {
      obj.customerConfirmedServices = customerConfirmedServices?.map(
        (item) => ({
          service: item,
          price: item?.paiPrice,
          patientTypeService: item?.paiPatientTypeService,
        })
      );
    }
    if (customerInterestedServices?.length > 0) {
      obj.customerInterestedServices = customerInterestedServices?.map(
        (item) => ({
          service: item,
        })
      );
    }
    if (customerConfirmedProducts?.length > 0) {
      obj.customerConfirmedProducts = customerConfirmedProducts?.map(
        (item) => ({
          drug: item,
          price: item?.paiPrice,
          patientTypeService: item?.paiPatientTypeService,
        })
      );
    }
    if (customerInterestedProducts?.length > 0) {
      obj.customerInterestedProducts = customerInterestedProducts?.map(
        (item) => ({
          drug: item,
        })
      );
    }

    if (customerConfirmedPrepaidCards?.length > 0) {
      obj.customerConfirmedPrepaidCards = customerConfirmedPrepaidCards?.map(
        (item) => ({
          clientCard: item,
          price: item?.paiPrice,
          patientTypeService: item?.paiPatientTypeService,
        })
      );
    }
    if (customerInterestedPrepaidCards?.length > 0) {
      obj.customerInterestedPrepaidCards = customerInterestedPrepaidCards?.map(
        (item) => ({
          clientCard: item,
        })
      );
    }

    if (customerConfirmedTreatmentCards?.length > 0) {
      obj.customerConfirmedTreatmentCards =
        customerConfirmedTreatmentCards?.map((item) => ({
          clientCard: item,
          price: item?.paiPrice,
          patientTypeService: item?.paiPatientTypeService,
        }));
    }
    if (customerInterestedTreatmentCards?.length > 0) {
      obj.customerInterestedTreatmentCards =
        customerInterestedTreatmentCards?.map((item) => ({
          clientCard: item,
        }));
    }
    if (this.selectedFiles?.length > 0) {
      obj.attachmentIds = this.selectedFiles.map((el) => el?.id);
    }
    let api = saveItemAdvise;
    if (obj?.id) {
      api = updateItemAdvise;
    }
    api({
      ...obj,
      staff: getCurrentStaff(),
      patientAdviceId: obj?.patientAdvice?.id,
    })
      .then(async ({ data }) => {
        this.handleGetItemAdviseById(
          this?.currentPatientAdvise?.patientAdvice?.id
        );
        this.selectedFiles = [];
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lưu thông tin có lỗi!");
      });
  };

  handleUpdateItemAdviseStatus = (obj) => {
    updateItemAdviseStatus({
      ...obj?.patientAdvice,
      result: obj?.result,
    })
      .then(async ({ data }) => {
        this.handleGetItemAdviseById(
          this?.currentPatientAdvise?.patientAdvice?.id
        );
      })
      .catch((error) => {
        console.error(error);
        toast.error("Cập nhật thông tin có lỗi!");
      });
  };

  handleGetItemById = (id) => {
    getItemAdviseById(id)
      .then(async ({ data }) => {
        console.log("data", data);
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy thông tin có lỗi!");
      });
  };

  handleGetItemAdviseById = async (id) => {
    if (id) {
      const { data } = await getPatientAdviseById(id);
      const formatItems = await Promise.all(
        (data?.items || []).map(async (item) => {
          //set up ảnh
          const attachmentIds = item?.attachments?.map((el) => el?.id) || [];

          let attachmentsData = [];
          if (attachmentIds.length > 0) {
            attachmentsData = await Promise.all(
              attachmentIds.map((id) => getFileById(id))
            );
          }

          let dataAttachmentConvert = attachmentsData?.map((el, ind) => ({
            path: el?.data,
            id: item?.attachments?.[ind]?.id,
            name: item?.attachments?.[ind]?.name,
          }));

          let convertLightGallary = dataAttachmentConvert?.map((el, ind) => {
            if (!(el?.path instanceof Blob)) {
              return {};
            }
            return {
              src: URL.createObjectURL(el?.path || ""),
              thumb: URL.createObjectURL(el?.path || ""),
              alt: el?.name,
            };
          });

          // setup giá
          let {
            customerConfirmedPrepaidCards,
            customerConfirmedProducts,
            customerConfirmedServices,
            customerConfirmedTreatmentCards,
          } = item;
          item.customerConfirmedServicesPrice = customerConfirmedServices?.map(
            (el) => el?.price || 0
          );

          item.customerConfirmedPrepaidCardsPrice =
            customerConfirmedPrepaidCards?.map((el) => el?.price || 0);

          item.customerConfirmedTreatmentCardsPrice =
            customerConfirmedTreatmentCards?.map((el) => el?.price || 0);

          item.customerConfirmedProductsPrice = customerConfirmedProducts?.map(
            (el) => el?.price || 0
          );

          return {
            ...item,
            dataAttachmentConvert,
            convertLightGallary,
          };
        })
      );

      this.currentPatientAdvise = {
        ...DEFAULT_PATIENT_ADVISE,
        patientAdvice: { ...data, items: formatItems },
        result: data?.result,
      };
    } else {
      this.currentPatientAdvise = {
        patientAdvice: null,
        result: null,
      };
    }
  };

  handleCloseChatBoxAdvise = (state) => {
    this.openChatBoxAdvise = state;
    this.selectedFiles = [];
  };

  setCurrentTab = (tab) => {
    if (tab !== this.currentTab) {
      this.tabHistory.push(this.currentTab);
      this.tabNext = [];
    }
    this.currentTab = tab;
  };

  goBackTab = () => {
    if (this.tabHistory.length > 0) {
      this.tabNext.push(this.currentTab);
      const previousTab = this.tabHistory.pop();
      this.currentTab = previousTab;
    }
  };

  goForwardTab = () => {
    if (this.tabNext.length > 0) {
      this.tabHistory.push(this.currentTab);
      const nextTab = this.tabNext.pop();
      this.currentTab = nextTab;
    }
  };

  setSelectedFiles = (list) => {
    this.selectedFiles = list;
  };

  handleOpenConfirmDialogAdviseItem = (status) => {
    this.openConfirmDeleteAdviseItem = status;
  };

  handleOpenHistoryAdviseItem = (status) => {
    this.openHistoryAdviseItem = status;
  };

  getCustomerSourceWalkIn = async () => {
    // when create patient ,firstPatientSource or currentPatientSource not provided
    //set default source have code NKV_VL in system config
    if (CUSTOMER_SOURCE_WALK_IN_CODE) {
      let { data } = await pagingCustomerSource({
        keyword: CUSTOMER_SOURCE_WALK_IN_CODE,
        pageSize: 1,
        pageIndex: 1,
      });
      this.customerSourceWalkIn = data?.content?.[0];
    }
  };

  handleConfirmDeleteAdviseItem = () => {
    deleteItemAdvise({
      ...this.openConfirmDeleteAdviseItem,
      staff: getCurrentStaff(),
      patientAdviceId: this.currentPatientAdvise?.patientAdvice?.id,
    })
      .then(async ({ data }) => {
        this.handleGetItemAdviseById(
          this?.currentPatientAdvise?.patientAdvice?.id
        );
        this.handleOpenConfirmDialogAdviseItem(false);
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lưu thông tin có lỗi!");
      });
  };

  handleGetListVatPercent = () => {
    pagingServiceVat({
      pageIndex: 1,
      pageSize: PAGESIZE_ALL,
    })
      .then(async ({ data }) => {
        this.listVatPercent = data?.content;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy thông tin vat có lỗi!");
      });
  };

  pagingPatientHistory = async () => {
    return await pagingElasticPatientHistory({
      ...this.searchDataHistoryPatient,
    })
      .then(({ data }) => {
        this.pageDataPatientHistory = data;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu lịch sử khách hàng có lỗi");
      });
  };

  handleCloseHistoryPatientPopup = async () => {
    this.openHistoryPatientPopup = false;
    this.searchDataHistoryPatient = null;
  };

  handleChangeFormSearchHistoryPatient = (searchDataHistoryPatient) => {
    this.searchDataHistoryPatient = {
      ...this.searchDataHistoryPatient,
      ...searchDataHistoryPatient,
    };
    this.pagingPatientHistory();
  };

  handleOpenHistoryPatientPopup = async (values) => {
    try {
      this.handleChangeFormSearchHistoryPatient(values);
      this.openHistoryPatientPopup = true;
    } catch (error) {
      toast.error(error);
    }
  };

  handleCloseUncompletedServicePopup = () => {
    this.openUncompletedServicePopup = false;
  };

  handleCloseHistoryStaffRevenuePopup = async () => {
    this.openHistoryStaffRevenuePopup = false;
    this.searchDataHistoryStaffRevenue = null;
  };

  handleChangeFormSearchHistoryStaffRevenue = (
    searchDataHistoryStaffRevenue
  ) => {
    this.searchDataHistoryStaffRevenue = {
      ...this.searchDataHistoryStaffRevenue,
      ...searchDataHistoryStaffRevenue,
    };
    this.pagingHistoryStaffRevenue();
  };

  pagingHistoryStaffRevenue = async () => {
    try {
      const { data } = await elasticStaffRevenueHistory({
        ...this.searchDataHistoryStaffRevenue,
      });
      this.pageStaffRevenueHistory = data;
    } catch (error) {
      console.error(error);
      toast.error("Lấy dữ liệu lịch sử phân bổ có lỗi");
    }
  };

  handleOpenHistoryStaffRevenuePopup = async (values) => {
    try {
      this.handleChangeFormSearchHistoryStaffRevenue(values);
      this.openHistoryStaffRevenuePopup = true;
    } catch (error) {
      toast.error(error);
    }
  };

  getDataInvoiceDebtFee = async (obj) => {
    return await getInvoiceItemByType({ ...obj, incompletePaymentItems: true })
      .then(async ({ data }) => {
        const { services, products, prepaidCards, treatmentCards } = data;

        let invoiceItems = [
          ...(services?.items || []),
          ...(products?.items || []),
          ...(prepaidCards?.items || []),
          ...(treatmentCards?.items || []),
        ];
        this.dataInvoiceDebtFee = invoiceItems;
        this.openInvoiceDebtFeePopup = true;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu invoice item có lỗi");
      });
  };

  handleCloseInvoiceDebtFeePopup = async () => {
    this.openInvoiceDebtFeePopup = false;
    this.dataInvoiceDebtFee = null;
  };

  handleOpenConfirmDeleteRelationship = (id) => {
    this.openConfirmDeleteRelationship = id;
  };

  handleDeleteRelationship = async () => {
    try {
      const { data } = await removeRalationship(
        this.openConfirmDeleteRelationship
      );
      toast.success("Xóa mối quan hệ thành công!");

      const patientId = this.initialPatient?.patientInfo?.id;
      if (patientId) {
        await this.handleGetPatientOverviewById(patientId);
      }
      this.openConfirmDeleteRelationship = null;
      return data;
    } catch (error) {
      console.error("Xóa mối quan hệ có lỗi:", error);
      toast.error("Xóa mối quan hệ có lỗi!");
    }
  };

  // Phần này là CRUD ghi chú của kh
  selectedNote = null;
  openNoteCreateOrUpdate = false;
  openConfirmDeleteNotePatient = false;
  openConfirmDeleteNote = false;
  handleOpenFormCreateOrEditNotePatient = (noteId) => {
    if (noteId) {
      getNotePatientById(noteId)
        .then(({ data }) => {
          this.selectedNote = data;
          this.openNoteCreateOrUpdate = true;
        })
        .catch((error) => {
          toast.error("Lấy dữ liệu Ghi chú có lỗi");
          console.error("Lỗi lấy dữ liệu Ghi chú:", error);
        });
    } else {
      this.selectedNote = new NotePatientType();
      this.openNoteCreateOrUpdate = true;
    }
  };

  handleCreateOrEditNotePatient = async (vatData) => {
    try {
      const { data } = await saveNotePatient(vatData);
      toast.success("Lưu Ghi chú thành công!");
      this.handleClosePopupNotePatien();
      const patientId = this.initialPatient?.patientInfo?.id;
      if (patientId) {
        await this.handleGetPatientOverviewById(patientId);
      }
      return data;
    } catch (error) {
      toast.error("Lưu Ghi chú thất bại!");
      console.error("Lưu Ghi chú thất bại!:", error);
    }
  };

  handleDeleteNotePatient = async () => {
    const noteId = this.selectedNote?.id;
    if (!noteId) return;
    try {
      const { data } = await deleteNotePatient(noteId);
      toast.success("Xóa Ghi chú thành công!");

      const patientId = this.initialPatient?.patientInfo?.id;
      if (patientId) {
        await this.handleGetPatientOverviewById(patientId);
      }
      this.openConfirmDeleteNotePatient = null;
      return data;
    } catch (error) {
      console.error("Xóa Ghi chú có lỗi:", error);
      toast.error("Xóa Ghi chú có lỗi!");
    }
  };

  handleDeleteNote = (note) => {
    this.selectedNote = note;
    this.openConfirmDeleteNotePatient = true;
  };

  handleClosePopupNotePatien = () => {
    this.openNoteCreateOrUpdate = false;
    this.openConfirmDeleteNotePatient = false;
  };

  resetStore = () => {
    this.initialPatient = { ...DEFAULT_VALUE };
    this.patientAdvise = null;
    this.currentPatientAdvise = {
      ...DEFAULT_PATIENT_ADVISE,
    };
    this.currentTab = 0;
    this.openChatBoxAdvise = false;
    this.openConfirmDeleteAdviseItem = false;
    this.openHistoryAdviseItem = false;
    this.listVatPercent = [];
    this.customerSourceWalkIn = null;
  };
}
